import Vue from "vue"
import VueRouter from "vue-router";
import store from "@/store/store";
import user_info_urls from "@/components/IBMS/header/user_info_urls";
import platform_urls from "@/components/IBMS/platform/platform_urls"
import CONFIG_urls from "@/components/IBMS/global/CONFIG/CONFIG_urls";

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
};
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },

        {
            path: '/login',
            components: {
                content: (resolve => {
                    require(["../components/IBMS/login/login"], resolve)
                })
            }
        },
        {
            path: '/forget',
            component: (resolve => {
                require(["../components/IBMS/login/forget"], resolve)
            })
        },
        //IBMS系统
        {
            path: '/IBMS',
            components: {
                top_head: (resolve => {
                    require(["../components/IBMS/header/header_nav"], resolve)
                }),
                content: (resolve => {
                    require(["../components/IBMS/function/page_group/outBox"], resolve)
                }),
            },
            children: [
                //用户资料
                ...user_info_urls,

                //建筑能源管理
                ...platform_urls,
                //系统配置管理
                ...CONFIG_urls,


            ]
        },


    ]
});

router.beforeEach((to, from, next) => {
    const func_list = store.state.func_list ? store.state.func_list : JSON.parse(window.sessionStorage.getItem('func_list'))
    const auth_key = store.state.auth_key ? store.state.auth_key : JSON.parse(window.sessionStorage.getItem('auth_key'))
    store.commit('get_auth_key', auth_key)
    store.commit('funcList', func_list)
    const project_name = store.state.project_name ? store.state.project_name : JSON.parse(window.sessionStorage.getItem('project_name '))
    store.commit('push_project_name', project_name)
    const platform_Id = store.state.platform_Id ? store.state.platform_Id : JSON.parse(window.sessionStorage.getItem('platform_Id'))
    store.commit('push_platform_id', platform_Id)
    next()
})
export default router
